import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import '../../styles/JobOrderReceipts.css';
import { s3TempBucketUploader, TEMP_BUCKET_NAME} from '../Promotions/config/aws-config-temp-bucket'; 
import logo from "../../images/BPMC_Logo.png";

async function fetchImageAsDataURL(imageUrl) {
  try {
    const response = await fetch(imageUrl, { mode: 'cors' });
    if (!response.ok) {
      throw new Error(`Failed to fetch image: ${response.statusText}`);
    }
    const blob = await response.blob();
    return URL.createObjectURL(blob);
  } catch (error) {
    console.error("Error fetching image as data URL:", error);
    throw error;
  }
}

const generateReceipts = async (data) => {  
  
    // Generate signed URLs for the accomplished and acknowledged signatures
  const accomplishedSignatureUrl = s3TempBucketUploader.getSignedUrl('getObject', {
    Bucket: TEMP_BUCKET_NAME,
    Key: `${data.id}-signature-accomplished.png`,
  });


  console.log("data", data)

  const acknowledgedSignatureUrl = s3TempBucketUploader.getSignedUrl('getObject', {
    Bucket: TEMP_BUCKET_NAME,
    Key: `${data.id}-signature-acknowledged.png`,
  });

  // Fetch the images as data URLs
  const [accomplishedSignatureDataUrl, acknowledgedSignatureDataUrl] = await Promise.all([
    fetchImageAsDataURL(accomplishedSignatureUrl),
    fetchImageAsDataURL(acknowledgedSignatureUrl)
  ]);


    // Create the container for PDF content
    const element = document.createElement('div');
    const sanitizedFindings = data.findings ? data.findings.replace(/</g, "&lt;").replace(/>/g, "&gt;") : '_________________________';
    

    element.className = 'receipt-container';  // Add this line to apply the styling class      
    // Fill element with receipt structure and data, or refer to an existing DOM element if needed
     // Add content dynamically
    element.innerHTML = `<div>   
        
        <div className="header" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
          <div className="logo" ">
            <img src=${logo} alt="Pest Control Logo"  style="width: 200px; height: auto;"/>
          </div>
          <div className="company-details" style="text-align: center;">
            <h2>Boaz Pest Control</h2>
            <p>Your Pest Control PROS!</p>
          </div>
          <div className="sdr-info" style="text-align: right;">
            <p>OPS-SR-01F1</p>
            <p><strong>SDR No:</strong> <span className="red-text" style="color: red;">${data.id || '00000'}</span></p>
          </div>
        </div>

        
        <div className="contact-info" style="display: flex; justify-content: space-between; padding: 10px 0; border-top: 1px solid #000; border-bottom: 1px solid #000;">
          <div className="left-contact" style="width: 33%;">
            <p style="font-size: 12px;"><strong>Contact Info:</strong></p>
            <p style="font-size: 12px;">Website: www.boazpestcontro.com</p>
            <p style="font-size: 12px;">Email: boazpestcontrol@gmail.com</p>
          </div>
          <div className="right-contact" style="width: 33%;">
            <p style="font-size: 12px;"><strong>Office Address:</strong></p>
            <p style="font-size: 12px;">8898 Sampaguita cor. P. Victor Sts., Guadlupe Nuevo, Makati City</p>
            <p style="font-size: 12px;">2 Mistletoe cor Mayflower Sts., Del Nacia 3, Talipapa, Quezon City</p>
          </div>
          <div className="numbers" style="width: 33%;">
            <p style="font-size: 12px;">T: 7729-3434/ 7744-4215</p>
            <p style="font-size: 12px;">M: (0922) 865-5906</p>
          </div>
        </div>

        
        <div className="title" style="text-align: center; font-weight: bold; background-color: #000; color: #fff; padding: .5px; margin: 5px 0;">
          <h3>Termite Control Service Delivery Receipt</h3>
        </div>

        
        <table className="service-table" style="width: 100%; border-collapse: collapse; margin: 10px 0;">
          <thead>
            <tr>
              <th className="left-align" style="text-align: left; padding: 8px; border: 1px solid #000;">Date:  ${data.actual_end_date}</th>
              <th className="left-align" style="text-align: left; padding: 8px; border: 1px solid #000;">Time In: ${data.actual_start_time}</th>
              <th className="left-align" style="text-align: left; padding: 8px; border: 1px solid #000;">Time Out: ${data.actual_end_time}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="padding: 8px; border: 1px solid #000;">Client: ${data.client_name}</td>
              <td style="padding: 8px; border: 1px solid #000;">Contact Person: ${data.contactFirstName} ${data.contactLastName}</td>
              <td style="padding: 8px; border: 1px solid #000;">Tel No.: ${data.contactNumber}</td>
            </tr>
            <tr>
              <td colSpan="3" style="padding: 8px; border: 1px solid #000;">Address: ${data.job_site_address}</td>
            </tr>
          </tbody>
        </table>

      <div className="follow-up-section" style="display: flex; gap: 10px; margin: 10px 0;">
          <label><input type="checkbox" checked=${data.type} readOnly /> Initial</label>
          <label><input type="checkbox" checked=${data.type} readOnly /> Follow-up</label>
        </div>
        
        <div className="inspection-findings" style=" display: flex; justify-content: space-between; margin: 10px 0;">
          <div><strong>Inspection done in:</strong> ${data.inspection_location || '_________________________'}</div>
          <div><strong>Findings:</strong> ${sanitizedFindings || '_________________________'}</div>
        </div>

        
        <div className="diagram-findings" style="margin-top: 20px;">
          <p><strong>Diagram of Activities/Findings</strong></p>
          <div className="diagram-box" style="width: 100%; height: 50px; border: 1px solid #000; margin-top: 5px;">${data.inspection_location }, ${sanitizedFindings || '_________________________'} ,  ${data.action_taken}</div>
          
        </div>

        
        <div className="actions-materials" >
          <table style="width: 100%; border: 1px solid #000; border-collapse: collapse; margin-top: 10px;">
            <tbody>
              <tr>
                <td style="padding: 8px; border: 1px solid #000;"><strong>Action Taken:</strong> ${data.action_taken}</td>
              </tr>
              <tr>
                <td style="padding: 8px; border: 1px solid #000;"><strong>Material/s Used:</strong> ${data.chemical_used}</td>
              </tr>
              <tr>
                <td style="padding: 8px; border: 1px solid #000;"><strong>Payment Status:</strong> ${data.payment_status}</td>
              </tr>
            </tbody>
          </table>
        </div>

        
        <div className="footer" style="display: flex; justify-content: space-between; margin-top: 20px;">
          <p><strong>Accomplished by:</strong> ${data.technicians.map(tech => `${tech.firstname} ${tech.lastname}`).join(', ')} </p>
          <p><strong>Acknowledged by:</strong> ${data.contactFirstName} ${data.contactLastName}</p>
        </div>

        <!-- Signatures -->
        <div class="signatures" style="display: flex; justify-content: space-between; margin-top: 20px;">
          <div style="text-align: center;">
            <p><strong>Accomplished By:</strong></p>
            <img src="${accomplishedSignatureDataUrl}" alt="Signature" style="width: 200px; height: 80px; border: 1px solid #000;" />
          
          </div>
          <div style="text-align: center;">
            <p><strong>Acknowledged By:</strong></p>
            <img src="${acknowledgedSignatureDataUrl}" alt="Signature1" style="width: 200px; height: 80px; border: 1px solid #000;" />
          </div>

           
        </div>
      </div>      
		

      </div>      
    </div>
  `; // Example content
    document.body.appendChild(element);

    try {
      // Generate the canvas and capture the element, ignoring iframes
      const canvas = await html2canvas(element, {
        scale: 1.5, // Reduce scale for smaller image size
        useCORS: true, // Enables CORS for external images
        logging: true,
        ignoreElements: (element) => element.tagName === "IFRAME", // Ignores iframes
      });
    
    //const canvas = await html2canvas(element);
    // Create the PDF
    const imgData = canvas.toDataURL('image/jpeg', '0.6');
    const pdf = new jsPDF('p', 'mm', 'a4');
    const imgWidth = 190;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    pdf.addImage(imgData, 'JPEG', 10, 10, imgWidth, imgHeight, undefined, 'FAST'); // Fast compression mode
    pdf.save('receipt.pdf'); // Save PDF to the user's device
    const pdfBlob = pdf.output("blob"); // Returns a Blob for S3 upload
    return pdfBlob;
    } catch (error) {
      console.error("Error generating PDF:", error);
    } finally {
      // Clean up by removing the temporary element
      document.body.removeChild(element);
    }
  };
  
  export default generateReceipts;
  